import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinkMutliselectComponent } from './link-mutliselect.component';
import { MultiSelectModule } from '../../primeng/components/multiselect/multiselect';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    MultiSelectModule
  ],
  exports: [
    LinkMutliselectComponent
  ],
  declarations: [LinkMutliselectComponent]
})
export class LinkMutliselectModule { }
